export const yearOptions = { year: "numeric" };
export const dateOptions = { month: "short", day: "numeric" };
export const dateOptionsLong = { month: "long", day: "numeric" };
export const dateOptionsNumeric = { month: "2-digit", day: "2-digit" };
export const monthNameText = { month: "long" };
export const secondsOptions = { second: "2-digit" };
export const time12Options = { hour: "numeric", minute: "2-digit", hourCycle: "h12" };
export const time24Options = { hour: "2-digit", minute: "2-digit", hourCycle: "h23" };
//# sourceMappingURL=dateTimeOptions.js.map